<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'common.historic-action'">Histórico de acciones sobre el documento</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-table__container-border">
      <div class="common-table-header__container">
        <div class="common-table-cell__container w-[33%]">
          <filter-by-list-and-order
            [item]="documentHistoric.userNameFilter"
            [list]="documentHistoric.userNameList"
            (launchActionFilterOrderEmit)="filterOrder($event, 'userName')">
          </filter-by-list-and-order>
        </div>
        <div class="common-table-cell__container w-[33%]">
          <filter-by-order
            [item]="documentHistoric.dateFilter"
            [filterOrder]="documentHistoric.filterOrder"
            [order]="documentHistoric.orderOperationDates"
            (launchActionFilterOrderEmit)="filterOrder($event)">
          </filter-by-order>
        </div>
        <div class="common-table-cell__container w-[34%]">
          <filter-by-list-and-order
            [item]="documentHistoric.actionFilter"
            [list]="documentHistoric.actionList"
            (launchActionFilterOrderEmit)="filterOrder($event, 'action')">
          </filter-by-list-and-order>
        </div>
      </div>
      <div class="common-table-body__container h-[230px]">
        @for (historic of documentHistoric.filterHistoricList | afOrderBy:documentHistoric.filterOrder:documentHistoric.orderOperationDates; track $index) {
          <div class="common-table-body__row-default">
            <div class="common-table-cell__container w-[33%]">
              <span-tooltip class="common-table-cell__standard-text-label"
                [text]="historic.userName"></span-tooltip>
            </div>
            <div class="common-table-cell__container w-[33%]">
              <span-tooltip class="common-table-cell__standard-text-label"
                [text]="historic.actionDate | convertDate: 'without-time'"></span-tooltip>
            </div>
            <div class="common-table-cell__container w-[34%]">
              @if (historic.participantsList?.length){
                <participants-list [participants]="historic.participantsList"
                  [previousAction]="historic.action"
                  [type]="historic.type">
                </participants-list>
              }@else{
                <span-tooltip class="common-table-cell__standard-text-label"
                  [text]="historic.action"></span-tooltip>
              }
            </div>
          </div>
        }
      </div>
      <div class="pagination-control">
        <div class="pagination-control__container-text-pagination">
          <span class="pagination-control__text-pagination-bold">
            <span [afTranslate]="'common.total'">_Total</span>:
            <span>{{documentHistoric.filterHistoricList.length}}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.close'">_Cerrar</span>
    </button>
  </div>
</div>
